import * as React from 'react';
import styled from '@emotion/styled';
import * as vars from '../../consts/variables';
import { __ } from '../../helpers/TranslationService';
import { Position } from '../Icons/Position';
import { Size } from '../Icons/Size';
import { UserIcon } from '../Icons/UserIcon';

const styles: Record<string, React.CSSProperties> = {
    title: {
        display: 'flex',
        fontWeight: 'bold',
        marginRight: 5,
        color: vars.lighterBlack,
    },
    description: {
        textAlign: 'left',
        marginBottom: 3,
        display: 'flex',
        color: vars.lighterBlack,
    },
};

interface IProps {
    title: string;
    text: string | string[];
}

const IconWrapper = styled.span`
    fill: ${({ theme }) => theme.icon.brandColor1};
    margin-right: 6px;
    flex: 0 0 auto;
`;

const getIconForTitle = (title: string) => {
    switch (title) {
        case 'Location':
            return (
                <IconWrapper>
                    <Position width={20} height={20} />
                </IconWrapper>
            );
        case 'Cabin size':
            return (
                <IconWrapper>
                    <Size width={20} height={20} />
                </IconWrapper>
            );
        case 'Occupancy':
            return (
                <IconWrapper>
                    <UserIcon width={20} height={20} />
                </IconWrapper>
            );
        default:
            return null;
    }
};

export function CabinDescription({ title, text }: IProps) {
    if (text) {
        if (Array.isArray(text) && text.length > 0) {
            const Items = text.map((item, index) => <li key={index}>{item}</li>);
            return (
                <div>
                    <span style={styles.title}>{`${__(title, 'dreamlines')}: `} </span>
                    <ul>{Items}</ul>
                </div>
            );
        }
        if (Array.isArray(text) && text.length === 0) {
            return null;
        }
        return (
            <div style={styles.description}>
                <span style={styles.title}>
                    {getIconForTitle(title)}
                    {`${__(title, 'dreamlines')}: `}
                </span>
                <span> {text}</span>
            </div>
        );
    }
    return null;
}
